import { useEffect, useRef, useState } from "react";
import { useMsal } from "@azure/msal-react";

export default function useIdleSessionTimeout({
  //idleMinutes = 1,
  //warningMinutes = 0.5,
  sessionMinutes = 1,
  warningSessionMinutes = 0.5,
  onLogout,
}) {
  const { instance, accounts } = useMsal();
  //const [showWarning, setShowWarning] = useState(false);
  const [showSessionWarning, setShowSessionWarning] = useState(false);
  const [timeLeft, setTimeLeft] = useState(sessionMinutes * 60 * 1000);
  //const idleTimer = useRef(null);
  //const warningTimer = useRef(null);
  const sessionTimer = useRef(null);
  const sessionWarningTimer = useRef(null);

  // Token refresh logic
  const refreshToken = async () => {
    if (accounts && accounts.length > 0) {
      try {
        await instance.acquireTokenSilent({
          account: accounts[0],
          scopes: ["user.read"], // Use your required scopes
        });
      } catch (e) {
        // If silent fails, force login
        await instance.loginRedirect();
      }
    }
  };

 /*  // Reset idle timer on user activity
  const resetIdleTimer = () => {
    // setShowWarning(false);
    clearTimeout(idleTimer.current);
    // clearTimeout(warningTimer.current);
    idleTimer.current = setTimeout(() => {
      // setShowWarning(true);
      // warningTimer.current = setTimeout(() => {
      //   setShowWarning(false);
      //   onLogout();
      // }, warningMinutes * 60 * 1000);
      onLogout(); // Directly logout after idleMinutes
    }, idleMinutes * 60 * 1000);
    // resetSessionTimer();
  }; */

  // Session timeout logic
  const resetSessionTimer = () => {
    // Always reset timeLeft to the correct session duration
    const sessionDurationMs = Number(sessionMinutes) * 60 * 1000;
    const warningDurationMs = Number(warningSessionMinutes) * 60 * 1000;
    setTimeLeft(sessionDurationMs);
    setShowSessionWarning(false);
    clearTimeout(sessionTimer.current);
    clearTimeout(sessionWarningTimer.current);
    sessionTimer.current = setTimeout(() => {
      onLogout();
    }, sessionDurationMs);
    sessionWarningTimer.current = setTimeout(() => {
       setTimeLeft(warningDurationMs);
      setShowSessionWarning(true);
    }, sessionDurationMs - warningDurationMs);
  };

 /* useEffect(() => {
    // Listen for user activity
    const events = ["keydown", "mousedown", "touchstart"];
    events.forEach((e) => window.addEventListener(e, resetSessionTimer));
    resetSessionTimer();
    return () => {
      events.forEach((e) => window.removeEventListener(e, resetSessionTimer));
      //clearTimeout(idleTimer.current);
      //clearTimeout(warningTimer.current);
      clearTimeout(sessionTimer.current);
      clearTimeout(sessionWarningTimer.current);
    };
  }, []); */

  // Handler for continue button (idle warning)
 /*  const handleContinue = async () => {
    setShowWarning(false);
    clearTimeout(warningTimer.current);
    await refreshToken();
    resetIdleTimer();
  }; */

  // Handler for extend session button (session warning)
  const handleSessionContinue = async () => {
    setShowSessionWarning(false);
    await refreshToken();
    resetSessionTimer();
  };

  // Session time left calculation
  useEffect(() => {
    if (!sessionTimer.current) return;
    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1000) return 0;
        return prev - 1000;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [sessionTimer.current]);

  // Start session timer on mount and when sessionMinutes/warningSessionMinutes change
  useEffect(() => {
    resetSessionTimer();
  }, [sessionMinutes, warningSessionMinutes]);

  // Ensure timeLeft updates when sessionMinutes changes
  useEffect(() => {
    setTimeLeft(sessionMinutes * 60 * 1000);
  }, [sessionMinutes]);

  // Listen for user activity to reset timer (only if warning not shown)
  useEffect(() => {
    const events = ["keydown", "mousedown", "touchstart"];
    const activityHandler = () => {
      if (!showSessionWarning) resetSessionTimer();
    };
    events.forEach((e) => window.addEventListener(e, activityHandler));
    return () => {
      events.forEach((e) => window.removeEventListener(e, activityHandler));
      clearTimeout(sessionTimer.current);
      clearTimeout(sessionWarningTimer.current);
    };
  }, [showSessionWarning]);

  // Logout when timer reaches 0
  useEffect(() => {
    if (timeLeft === 0) {
      onLogout();
    }
  }, [timeLeft]);

  return {
   // showWarning,
   // handleContinue,
    showSessionWarning,
    handleSessionContinue,
    timeLeft,
    resetSessionTimer,
  };
}
